import React from 'react';

const Hero = () => {
  return (
    <section className="min-h-[60vh] pt-20 flex items-center hero-gradient">
      <div className="container mx-auto px-4 py-6 grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
        <div className="text-center lg:text-right space-y-6 animate-fade-in">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold">
            <span className="text-brand-black">اكتشف</span>{" "}
            <span className="text-brand-pink">فن العطور والبخور</span>{" "}
            <span className="text-brand-black">معنا</span>
          </h1>
          
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
            زجاجات مزينة بفن يدوي تعبّر عن الذوق الرفيع في كل مناسبة
          </p>
        </div>
        
        <div className="flex justify-center lg:justify-end animate-slide-in">
          <div className="relative w-64 h-64 md:w-80 md:h-80 lg:w-[400px] lg:h-[400px]">
            <img 
              src="/lovable-uploads/1756892057107-kh4h7vyzr9d.webp" 
              alt="عروسة عدن - شعار" 
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;